/**
 * Dynamische Aktualisierung von SKU und EAN bei Variantenänderung
 */
(function() {
  'use strict';

  let variantChangeUnsubscriber = undefined;
  let initAttempts = 0;
  const MAX_INIT_ATTEMPTS = 50; // 5 Sekunden max

  // Warte bis DOM und Event-System bereit sind
  function startInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  startInit();

  function init() {
    initAttempts++;
    
    // Prüfe ob alle benötigten Funktionen verfügbar sind
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      if (initAttempts < MAX_INIT_ATTEMPTS) {
        setTimeout(init, 100);
      } else {
        console.warn('variant-sku-barcode.js: PUB_SUB_EVENTS oder subscribe nicht gefunden');
      }
      return;
    }

    // Abonniere Variantenänderungs-Events
    try {
      variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
      console.log('variant-sku-barcode.js: Event-Listener registriert');
    } catch (e) {
      console.error('variant-sku-barcode.js: Fehler beim Registrieren des Event-Listeners', e);
      return;
    }

    // Initialisiere auch beim ersten Laden - warte bis DOM vollständig geladen ist
    setTimeout(function() {
      // Prüfe ob Elemente existieren
      const skuElements = document.querySelectorAll('.variant-sku');
      const barcodeElements = document.querySelectorAll('.variant-barcode');
      console.log('variant-sku-barcode.js: Initiale Suche - SKU-Elemente:', skuElements.length, 'Barcode-Elemente:', barcodeElements.length);
      
      // Lade initiale Variante aus JSON
      const variantDataScript = document.querySelector('script[data-selected-variant]');
      if (variantDataScript) {
        try {
          const initialVariant = JSON.parse(variantDataScript.textContent);
          if (initialVariant) {
            console.log('variant-sku-barcode.js: Initiale Variante geladen', initialVariant);
            updateSkuAndBarcode(initialVariant.sku, initialVariant.barcode);
          }
        } catch (e) {
          console.warn('variant-sku-barcode.js: Konnte initiale Variantendaten nicht laden:', e);
        }
      } else {
        console.warn('variant-sku-barcode.js: Kein script[data-selected-variant] gefunden');
        // Fallback: Versuche Variante aus dem versteckten Input zu lesen
        const variantIdInput = document.querySelector('input[name="id"]');
        if (variantIdInput && variantIdInput.value) {
          console.log('variant-sku-barcode.js: Varianten-ID aus Input gefunden:', variantIdInput.value);
        }
      }
    }, 500);
  }

  function updateFromCurrentVariant() {
    // Versuche Variantendaten aus dem DOM zu extrahieren
    const variantDataScript = document.querySelector('script[data-selected-variant]');
    if (variantDataScript) {
      try {
        const variant = JSON.parse(variantDataScript.textContent);
        updateSkuAndBarcode(variant.sku, variant.barcode);
      } catch (e) {
        console.warn('variant-sku-barcode.js: Fehler beim Parsen der Variantendaten', e);
      }
    }
  }

  function handleVariantChange(event) {
    console.log('variant-sku-barcode.js: Variantenänderung erkannt', event);
    
    if (!event || !event.data || !event.data.variant) {
      console.warn('variant-sku-barcode.js: Ungültiges Event-Objekt', event);
      return;
    }

    const variant = event.data.variant;
    console.log('variant-sku-barcode.js: Aktualisiere SKU/EAN', {
      sku: variant.sku,
      barcode: variant.barcode,
      variantId: variant.id
    });
    
    // Warte kurz, damit DOM-Updates abgeschlossen sind
    setTimeout(function() {
      updateSkuAndBarcode(variant.sku, variant.barcode);
    }, 100);
  }

  function updateSkuAndBarcode(sku, barcode) {
    // Suche in allen product-info Containern (falls mehrere auf der Seite)
    const productInfoContainers = document.querySelectorAll('product-info');
    
    if (productInfoContainers.length === 0) {
      console.warn('variant-sku-barcode.js: Kein product-info Container gefunden');
    }
    
    // Aktualisiere SKU
    const skuElements = document.querySelectorAll('.variant-sku');
    console.log('variant-sku-barcode.js: Gefundene SKU-Elemente:', skuElements.length, 'SKU-Wert:', sku);
    
    if (skuElements.length === 0) {
      console.warn('variant-sku-barcode.js: Keine Elemente mit Klasse .variant-sku gefunden');
      console.warn('variant-sku-barcode.js: Suche im gesamten DOM...');
      // Debug: Zeige alle span-Elemente
      const allSpans = document.querySelectorAll('span');
      console.log('variant-sku-barcode.js: Gesamte Anzahl span-Elemente:', allSpans.length);
    }
    
    skuElements.forEach((element, index) => {
      if (sku !== undefined) {
        const oldValue = element.textContent.trim();
        const newValue = (sku || '').trim();
        element.textContent = newValue;
        console.log('variant-sku-barcode.js: SKU Element #' + (index + 1) + ' aktualisiert von "' + oldValue + '" zu "' + newValue + '"');
        
        // Verstecke/Zeige Parent-Element basierend auf SKU
        let parent = element.parentElement;
        while (parent && parent !== document.body) {
          if (parent.tagName === 'P' || parent.tagName === 'DIV' || parent.classList.contains('custom_liquid')) {
            if (newValue) {
              parent.classList.remove('visibility-hidden');
              parent.style.display = '';
            } else {
              parent.classList.add('visibility-hidden');
            }
            break;
          }
          parent = parent.parentElement;
        }
      }
    });

    // Aktualisiere EAN/Barcode
    const barcodeElements = document.querySelectorAll('.variant-barcode');
    console.log('variant-sku-barcode.js: Gefundene Barcode-Elemente:', barcodeElements.length, 'Barcode-Wert:', barcode);
    
    if (barcodeElements.length === 0) {
      console.warn('variant-sku-barcode.js: Keine Elemente mit Klasse .variant-barcode gefunden');
    }
    
    barcodeElements.forEach((element, index) => {
      if (barcode !== undefined) {
        const oldValue = element.textContent.trim();
        const newValue = (barcode || '').trim();
        element.textContent = newValue;
        console.log('variant-sku-barcode.js: Barcode Element #' + (index + 1) + ' aktualisiert von "' + oldValue + '" zu "' + newValue + '"');
        
        // Verstecke/Zeige Parent-Element basierend auf Barcode
        let parent = element.parentElement;
        while (parent && parent !== document.body) {
          if (parent.tagName === 'P' || parent.tagName === 'DIV' || parent.classList.contains('custom_liquid')) {
            if (newValue) {
              parent.classList.remove('visibility-hidden');
              parent.style.display = '';
            } else {
              parent.classList.add('visibility-hidden');
            }
            break;
          }
          parent = parent.parentElement;
        }
      }
    });
  }

  // Cleanup beim Entladen der Seite
  window.addEventListener('beforeunload', function() {
    if (variantChangeUnsubscriber) {
      variantChangeUnsubscriber();
    }
  });
})();

